"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var primitives_1 = require("../../primitives");
exports.default = {
    sm: primitives_1.shadow[0],
    md: primitives_1.shadow[1],
    lg: primitives_1.shadow[2],
    xl: primitives_1.shadow[3],
    '2xl': primitives_1.shadow[4],
};
